import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

const Navbar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "rgba(249, 252, 251, 0.8)",
        backdropFilter: "blur(8px)",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box
            onClick={() => navigate("/")}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              gap: 1,
            }}
          >
            <AutoStoriesIcon
              color="primary"
              sx={{ fontSize: isMobile ? "1.5rem" : "2rem" }}
            />
            <Typography
              variant="h6"
              color="primary"
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "1rem" : "1.25rem",
                display: { xs: "none", sm: "block" },
              }}
            >
              Thesis Genius
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          {location.pathname === "/" ? (
            <Button
              variant="contained"
              onClick={() => navigate("/generator")}
              sx={{
                px: { xs: 2, md: 3 },
                py: 1,
                fontWeight: 600,
              }}
            >
              Start Writing
            </Button>
          ) : (
            <Button
              variant="outlined"
              onClick={() => navigate("/")}
              sx={{
                px: { xs: 2, md: 3 },
                py: 1,
                fontWeight: 600,
              }}
            >
              Back to Home
            </Button>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar;
